(function () {
  'use strict';
  if (window.masQuantityStockPriceReady) return;
  window.masQuantityStockPriceReady = true;
  // MAS quantity/cart cap V3 — full-stock choices, capped native Add.
  window.hdtPdpRecommendedQtyPriceReady = true;
  var selector = '.hdt-product-form__quantity[data-product-form-id]';
  var states = new Map();
  var linkingQuantity = false;
  var cartQuantities = null;
  var cartRevision = 0;
  var cartRequestId = 0;
  var cartRequest = null;
  var frame = 0;
  var pendingCommit = false;
  var submitFlow = null;
  var flowSequence = 0;
  var lastCart = null;
  var drawerNotice = null;

  function number(value, fallback) {
    var result = Number(value);
    return value !== null && value !== '' && Number.isFinite(result) ? result : fallback;
  }
  function attr(element, name, value) {
    var text = String(value);
    if (element.getAttribute(name) !== text) element.setAttribute(name, text);
  }
  function money(cents) {
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active || 'AUD';
    var format = window.themeHDN && window.themeHDN.settings && window.themeHDN.settings.currencyFormat;
    // Keep this formatter local: the previous global formatMoney called itself.
    var token = format && format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!token) return (cents / 100).toFixed(2) + ' ' + currency;
    var kind = token[1];
    var decimals = kind.indexOf('no_decimals') === -1 ? 2 : 0;
    var separator = kind.indexOf('comma_separator') > -1 ? '.' : ',';
    if (kind.indexOf('space_separator') > -1) separator = ' ';
    if (kind.indexOf('apostrophe_separator') > -1) separator = "'";
    var parts = (cents / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    var decimal = kind.indexOf('comma_separator') > -1 ? ',' : '.';
    // Liquid money format may contain markup; insert only its visible text.
    var template = document.createElement('template');
    template.innerHTML = format.replace(token[0], parts.join(decimal));
    return template.content.textContent;
  }
  function sourceFor(formId) {
    return Array.from(document.querySelectorAll('[data-pdp-qty-price-map]')).find(function (el) {
      return el.getAttribute('data-pdp-qty-price-map') === formId;
    });
  }
  function variantFor(state) {
    var form = document.getElementById(state.formId);
    var master = form && (form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]'));
    var id = master ? master.value : state.wrapper.getAttribute('variant-id');
    return { id: String(id || ''), data: state.map.variants[String(id || '')] };
  }
  function limits(state, selected) {
    var variant = selected.data;
    var inCart = cartQuantities ? (cartQuantities[selected.id] || 0) : number(variant.cartQuantity, 0);
    var step = Math.max(1, number(variant.step, 1));
    var minimum = Math.max(1, number(variant.min, 1));
    var cap = 9999;
    if (variant.inventoryManagement && variant.inventoryPolicy !== 'continue') cap = Math.max(0, number(variant.inventoryQuantity, 0));
    if (number(variant.max, 0) > 0) cap = Math.min(cap, number(variant.max, cap));
    if (!variant.available) cap = 0;
    var remaining = Math.max(0, cap - inCart);
    var min = inCart >= minimum ? step : minimum;
    var max = cap < min ? 0 : min + Math.floor((cap - min) / step) * step;
    var addMax = remaining < min ? 0 : min + Math.floor((remaining - min) / step) * step;
    return { min: max ? min : 0, max: max, step: step, cap: cap, cart: inCart, addMax: addMax };
  }
  function acceptCart(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var quantities = Object.create(null);
    cart.items.forEach(function (item) {
      var id = String(item.variant_id || item.id);
      quantities[id] = (quantities[id] || 0) + number(item.quantity, 0);
    });
    cartQuantities = quantities;
    lastCart = cart;
    return true;
  }
  function cancelCartRead() {
    cartRequestId += 1;
    if (cartRequest) cartRequest.abort();
    cartRequest = null;
  }
  function refreshCart() {
    if (typeof window.fetch !== 'function') return Promise.resolve(null);
    cancelCartRead();
    var requestId = cartRequestId;
    var revision = cartRevision;
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    cartRequest = controller;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    var options = { credentials: 'same-origin', cache: 'no-store' };
    if (controller) options.signal = controller.signal;
    // A restored page can contain an old cart snapshot even when the header is current.
    // This read updates only this controller; native cart events remain unchanged.
    return window.fetch(root + 'cart.js', options).then(function (response) {
      if (!response.ok) throw new Error('Cart refresh failed');
      return response.json();
    }).then(function (cart) {
      if (requestId !== cartRequestId || revision !== cartRevision) return revision !== cartRevision ? lastCart : null;
      if (!acceptCart(cart)) return null;
      schedule();
      return cart;
    }).catch(function () {
      // Keep the last known cart on network failure or cancellation.
      return revision !== cartRevision ? lastCart : null;
    }).then(function (cart) {
      if (requestId === cartRequestId) cartRequest = null;
      return cart;
    });
  }
  function normalized(value, rule) {
    if (!rule.max) return 0;
    var quantity = Math.min(rule.max, Math.max(rule.min, number(value, rule.min)));
    return rule.min + Math.floor((quantity - rule.min) / rule.step) * rule.step;
  }
  function ownDisabled(state, element, disabled) {
    if (disabled) {
      if (!element.disabled || state.disabled.has(element)) {
        state.disabled.add(element);
        element.disabled = true;
      }
    } else if (state.disabled.has(element)) {
      if (element.getAttribute('aria-busy') !== 'true') element.disabled = false;
      state.disabled.delete(element);
    }
  }
  function purchaseControls(state, blocked) {
    var form = document.getElementById(state.formId);
    if (!form) return;
    Array.from(form.elements).filter(function (el) { return el.type === 'submit'; }).forEach(function (el) {
      ownDisabled(state, el, blocked);
    });
    form.querySelectorAll('.shopify-payment-button, shopify-accelerated-checkout').forEach(function (el) {
      if (blocked && !el.hidden) { state.hidden.add(el); el.hidden = true; }
      else if (!blocked && state.hidden.has(el)) { el.hidden = false; state.hidden.delete(el); }
    });
    if (blocked) {
      if (!state.input.readOnly) { state.readOnly = true; state.input.readOnly = true; }
      state.input.setCustomValidity('This selection is currently sold out.');
      state.validity = true;
    } else {
      if (state.readOnly) { state.input.readOnly = false; state.readOnly = false; }
      if (state.validity) { state.input.setCustomValidity(''); state.validity = false; }
    }
  }
  function updatePills(state, rule, quantity) {
    var buttons = Array.from(state.root.querySelectorAll('[data-recommended-qty]'));
    var exact = buttons.some(function (button) { return number(button.dataset.masBaseQuantity, 0) === rule.max; });
    var replaced = false;
    buttons.forEach(function (button) {
      var base = number(button.dataset.masBaseQuantity, 0);
      var value = base;
      if (rule.max && !exact && !replaced && base > rule.max) { value = rule.max; replaced = true; }
      var disabled = !rule.max || value < rule.min || value > rule.max || (value - rule.min) % rule.step !== 0;
      attr(button, 'data-recommended-qty', value);
      var label = button.querySelector('span');
      if (label && label.textContent !== String(value)) label.textContent = String(value);
      button.disabled = disabled;
      attr(button, 'aria-disabled', disabled);
      var selected = !disabled && quantity === value;
      button.classList.toggle('is-selected', selected);
      attr(button, 'aria-pressed', selected);
    });
  }
  function updatePrices(state, variant, quantity) {
    if (!Number.isFinite(quantity)) return;
    // With no additional stock, retain the product's unit prices rather than show a free item.
    var displayQuantity = quantity > 0 ? quantity : 1;
    var changed = false;
    document.querySelectorAll('hdt-qty-price[form], hdt-compare-at-price[form]').forEach(function (element) {
      if (element.getAttribute('form') !== state.formId) return;
      var compare = element.tagName.toLowerCase() === 'hdt-compare-at-price';
      var cents = number(compare ? variant.compareAtPrice : variant.price, 0) * displayQuantity;
      var moneyElement = element.querySelector('.hdt-money');
      if (!compare) attr(element, 'variant-price', variant.price);
      if (compare) element.hidden = !(variant.compareAtPrice > variant.price);
      if (moneyElement) {
        var text = money(cents);
        if (moneyElement.textContent !== text) { moneyElement.textContent = text; changed = true; }
      }
    });
    if (changed) document.dispatchEvent(new CustomEvent('currency:update'));
  }
  function updateUnit(state, variant, quantity) {
    var title = variant.title || '';
    var pack = title.match(/\bpack\s+(\d+)\s+pcs?\b/i);
    var isPack = /\bpack\b/i.test(title);
    var note = state.root.querySelector('[data-mas-quantity-unit]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'mas-quantity-unit';
      note.setAttribute('data-mas-quantity-unit', '');
      note.setAttribute('aria-live', 'polite');
      state.root.appendChild(note);
    }
    var text = variant.bundleQuantityLabel || (isPack ? 'Quantity is in packs.' : '');
    if (pack) text += ' 1 pack = ' + pack[1] + ' pcs.';
    if (quantity > 1 && !variant.bundleQuantityLabel) text += (text ? ' ' : '') + quantity + (isPack ? ' packs' : ' units') + ' × ' + money(variant.price) + ' each.';
    if (note.textContent !== text) note.textContent = text;
    note.hidden = !text;
  }
  // Main and desktop sticky forms represent the same selection. Bundle forms stay separate.
  function syncLinkedQuantity(state) {
    if (linkingQuantity || state.writing || state.editingBlank) return;
    var section = state.root.closest('.hdt-main-section--product');
    var sticky = section && section.querySelector('hdt-sticky-btn-atc[form]');
    var stickyForm = sticky && sticky.querySelector('form');
    if (!stickyForm) return;
    var ids = [sticky.getAttribute('form'), stickyForm.getAttribute('id')];
    if (ids.indexOf(state.formId) === -1) return;
    var other = Array.from(states.values()).find(function (candidate) {
      return candidate !== state && ids.indexOf(candidate.formId) !== -1 && candidate.root.closest('.hdt-main-section--product') === section;
    });
    if (!other || variantFor(other).id !== variantFor(state).id) return;
    linkingQuantity = true;
    try {
      other.editingBlank = false;
      other.input.value = state.input.value;
      sync(other, true);
      other.quantityIntent = other.input.value;
      other.input.dispatchEvent(new Event('change', { bubbles: true }));
    } finally { linkingQuantity = false; }
  }
  function sync(state, commit) {
    if (!state.root.isConnected || state.writing) return;
    var selected = variantFor(state);
    if (!selected.data) return;
    var rule = limits(state, selected);
    state.rule = rule;
    state.variantId = selected.id;
    var input = state.input;
    if (state.afterAdd && state.afterAdd.cart === lastCart) {
      if (state.afterAdd.variantId === selected.id) input.value = normalized(state.afterAdd.quantity, rule);
      state.afterAdd = null;
    }
    attr(input, 'data-cart-quantity', rule.cart);
    attr(input, 'data-max', rule.cap);
    attr(input, 'min', rule.min);
    attr(input, 'max', rule.max);
    attr(input, 'step', rule.step);
    var parsed = number(input.value, NaN);
    if ((commit && !state.editingBlank) || !rule.max || (Number.isFinite(parsed) && (parsed < rule.min || parsed > rule.max || (parsed - rule.min) % rule.step !== 0))) input.value = normalized(input.value, rule);
    var actual = number(input.value, NaN);
    var valid = rule.max && Number.isFinite(actual) && actual >= rule.min && actual <= rule.max && (actual - rule.min) % rule.step === 0;
    state.root.querySelectorAll('.hdt-quantity__button').forEach(function (button) {
      var disabled = !rule.max || (button.name === 'minus' ? actual <= rule.min : actual >= rule.max);
      button.disabled = disabled;
      button.classList.toggle('disabled', disabled);
      attr(button, 'aria-disabled', disabled);
    });
    updatePills(state, rule, valid ? actual : 0);
    updateUnit(state, selected.data, valid ? actual : 0);
    purchaseControls(state, !rule.max);
    if (valid || !rule.max) updatePrices(state, selected.data, actual);
    else if (input.value === '') updatePrices(state, selected.data, 0);
  }
  function schedule(commit) {
    pendingCommit = pendingCommit || commit !== false;
    if (frame) return;
    frame = requestAnimationFrame(function () {
      frame = 0;
      var shouldCommit = pendingCommit;
      pendingCommit = false;
      states.forEach(function (state, root) {
        if (!root.isConnected) { state.observer.disconnect(); states.delete(root); }
        else sync(state, shouldCommit);
      });
    });
  }
  function setQuantity(state, value) {
    state.editingBlank = false;
    sync(state, true);
    state.input.value = normalized(value, state.rule);
    state.writing = true;
    state.input.dispatchEvent(new Event('input', { bubbles: true }));
    state.input.dispatchEvent(new Event('change', { bubbles: true }));
    state.writing = false;
    sync(state, true);
    syncLinkedQuantity(state);
  }
  function init(root) {
    var widgets = [];
    if (root.nodeType === 1 && root.matches(selector)) widgets.push(root);
    if (root.querySelectorAll) widgets = widgets.concat(Array.from(root.querySelectorAll(selector)));
    widgets.forEach(function (widget) {
      if (states.has(widget)) return;
      var formId = widget.dataset.productFormId;
      var source = sourceFor(formId);
      var input = widget.querySelector('input[name="quantity"]');
      var wrapper = widget.querySelector('hdt-quantity-wrapp');
      if (!source || !input || !wrapper) return;
      var map;
      try { map = JSON.parse(source.textContent); } catch (error) { return; }
      var state = { root: widget, formId: formId, input: input, wrapper: wrapper, map: map, disabled: new Set(), hidden: new Set(), writing: false };
      widget.querySelectorAll('[data-recommended-qty]').forEach(function (button) {
        attr(button, 'data-mas-base-quantity', button.getAttribute('data-recommended-qty'));
      });
      input.addEventListener('input', function () {
        state.editingBlank = input.value === '';
        sync(state, false);
        if (!state.editingBlank) state.quantityIntent = input.value;
        syncLinkedQuantity(state);
      });
      input.addEventListener('change', function (event) {
        var sameVariant = variantFor(state).id === state.variantId;
        if (!event.bubbles && sameVariant) {
          // Native Qn resets quantity after a cart update; keep this form's choice.
          if (state.editingBlank) input.value = '';
          else if (state.quantityIntent !== undefined) input.value = state.quantityIntent;
        } else state.editingBlank = false;
        sync(state, true);
        if (!state.editingBlank) state.quantityIntent = input.value;
        syncLinkedQuantity(state);
        schedule();
      });
      input.addEventListener('blur', function () {
        state.editingBlank = false;
        sync(state, true);
        state.quantityIntent = input.value;
        syncLinkedQuantity(state);
      });
      state.observer = new MutationObserver(function (records) {
        schedule(records.some(function (record) { return record.type === 'attributes'; }));
      });
      state.observer.observe(wrapper, { subtree: true, attributes: true, attributeFilter: ['max', 'min', 'step', 'data-max', 'data-cart-quantity', 'variant-id'] });
      document.querySelectorAll('hdt-qty-price[form], hdt-compare-at-price[form]').forEach(function (price) {
        if (price.getAttribute('form') === formId) state.observer.observe(price, { childList: true, characterData: true, subtree: true });
      });
      states.set(widget, state);
      sync(state, true);
      state.quantityIntent = input.value;
    });
  }
  document.addEventListener('click', function (event) {
    var target = event.target.closest && event.target.closest('[data-recommended-qty], .hdt-quantity__button');
    var root = target && target.closest(selector);
    var state = root && states.get(root);
    if (!state) return;
    event.preventDefault();
    event.stopPropagation();
    if (target.disabled) return;
    var value = target.hasAttribute('data-recommended-qty') ? number(target.getAttribute('data-recommended-qty'), 1) : number(state.input.value, 0) + (target.name === 'plus' ? state.rule.step : -state.rule.step);
    setQuantity(state, value);

  }, true);
  function showMessage(state, text, cart) {
    var node = state.root.querySelector('[data-mas-cart-message]');
    if (!node) {
      node = document.createElement('p');
      node.setAttribute('data-mas-cart-message', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.className = 'mas-cart-quantity-message';
      state.root.appendChild(node);
    }
    node.textContent = text;
    node.hidden = !text;
    if (cart) {
      drawerNotice = { text: text, cart: cart };
      renderDrawerNotice();
    }
  }
  function renderDrawerNotice() {
    if (!drawerNotice) return;
    var host = document.querySelector('#CartDrawer .hdt-mini-cart__sroll');
    if (!host) return;
    var node = host.querySelector('[data-mas-cart-drawer-message]');
    if (!node) {
      node = document.createElement('p');
      node.setAttribute('data-mas-cart-drawer-message', '');
      node.setAttribute('role', 'status');
      node.setAttribute('aria-live', 'polite');
      node.className = 'mas-cart-quantity-message';
      host.insertBefore(node, host.firstChild);
    }
    if (node.textContent !== drawerNotice.text) node.textContent = drawerNotice.text;
  }
  function clearMessages() {
    drawerNotice = null;
    document.querySelectorAll('[data-mas-cart-message], [data-mas-cart-drawer-message]').forEach(function (node) { node.remove(); });
  }
  function openCart() {
    var drawer = document.getElementById('CartDrawer');
    if (drawer && typeof drawer.openDialog === 'function') drawer.openDialog();
    else window.location.assign((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart');
  }
  function setAttemptBusy(flow) {
    flow.controls = [];
    var seen = new Set();
    states.forEach(function (state) {
      var form = document.getElementById(state.formId);
      if (!form) return;
      Array.from(form.elements).filter(function (el) { return el.type === 'submit'; }).forEach(function (el) {
        if (seen.has(el)) return;
        seen.add(el);
        flow.controls.push({ element: el, state: state, disabled: el.disabled, busy: el.getAttribute('aria-busy') });
        if (!el.disabled) { el.disabled = true; el.setAttribute('aria-busy', 'true'); }
      });
    });
  }
  function restoreAttemptBusy(flow) {
    (flow.controls || []).forEach(function (entry) {
      var selected = variantFor(entry.state);
      if (!entry.disabled && selected.data && selected.data.available) entry.element.disabled = false;
      if (entry.busy === null) entry.element.removeAttribute('aria-busy');
      else entry.element.setAttribute('aria-busy', entry.busy);
    });
  }
  function finishAttempt(flow) {
    if (submitFlow !== flow) return false;
    clearTimeout(flow.timer);
    restoreAttemptBusy(flow);
    submitFlow = null;
    return true;
  }
  function refreshVisibleCart() {
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  }
  async function beginAdd(state, form, submitter) {
    if (form.checkBreak) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    state.editingBlank = false;
    sync(state, true);
    if (!state.rule || !state.rule.max) return;
    var selected = variantFor(state);
    var flow = { id: ++flowSequence, state: state, form: form, variantId: selected.id, requested: normalized(state.input.value, state.rule), phase: 'checking' };
    submitFlow = flow;
    clearMessages();
    setAttemptBusy(flow);
    flow.timer = setTimeout(function () {
      if (submitFlow !== flow) return;
      if (flow.phase === 'checking') {
        cancelCartRead();
        finishAttempt(flow);
        showMessage(state, 'We couldn’t refresh your cart. Please try again.');
        return;
      }
      // A timed-out POST can still finish. Keep its guard until native success/error;
      // another click opens the cart rather than sending a duplicate request.
      flow.expired = true;
      restoreAttemptBusy(flow);
      showMessage(state, 'Your cart is taking longer to update. Please check your cart before trying again.');
      refreshVisibleCart();
    }, 30000);
    var cart = await refreshCart();
    if (submitFlow !== flow) return;
    if (!cart) {
      finishAttempt(flow);
      showMessage(state, 'We couldn’t refresh your cart. Please try again.');
      return;
    }
    if (!form.isConnected || document.getElementById(state.formId) !== form || state.input.form !== form || variantFor(state).id !== flow.variantId) {
      finishAttempt(flow);
      showMessage(state, 'Your selection changed. Please add your selected item again.');
      return;
    }
    if (state.input.value === '' || normalized(state.input.value, state.rule) !== flow.requested) {
      finishAttempt(flow);
      showMessage(state, 'Your quantity changed. Please add your selected quantity again.');
      return;
    }
    sync(state, true);
    var rule = state.rule;
    if (form.checkBreak || !rule || !rule.max) { finishAttempt(flow); return; }
    if (!form.checkValidity()) { finishAttempt(flow); form.reportValidity(); return; }
    if (!rule.addMax) {
      finishAttempt(flow);
      refreshVisibleCart();
      showMessage(state, 'Your cart already contains ' + rule.cart + '.', cart);
      openCart();
      return;
    }
    flow.actual = Math.min(flow.requested, rule.addMax);
    flow.before = rule.cart;
    setQuantity(state, flow.actual);
    restoreAttemptBusy(flow);
    flow.phase = 'native';
    flow.passNative = true;
    try {
      var button = submitter && submitter.form === form && !submitter.disabled ? submitter : undefined;
      window.HTMLFormElement.prototype.requestSubmit.call(form, button);
      if (!flow.nativePassed && submitFlow === flow) finishAttempt(flow);
    } catch (error) {
      finishAttempt(flow);
      showMessage(state, 'Please check your selection and try again.');
    } finally { flow.passNative = false; }
  }
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var state = Array.from(states.values()).find(function (item) { return form.getAttribute('id') === item.formId; });
    if (!state) return;
    if (submitFlow && submitFlow.form === form && submitFlow.passNative) {
      submitFlow.nativePassed = true;
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submitFlow) {
      if (submitFlow.expired) { refreshVisibleCart(); openCart(); }
      return;
    }
    beginAdd(state, form, event.submitter);
  }, true);
  document.addEventListener('variant:add', function (event) {
    var flow = submitFlow;
    if (!flow || flow.phase !== 'native' || event.target !== flow.form) return;
    var cart = event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    var total = cart.items.reduce(function (sum, item) { return String(item.variant_id || item.id) === flow.variantId ? sum + number(item.quantity, 0) : sum; }, 0);
    flow.state.afterAdd = { cart: cart, variantId: flow.variantId, quantity: flow.actual };
    finishAttempt(flow);
    if (!flow.expired && flow.actual < flow.requested && variantFor(flow.state).id === flow.variantId) showMessage(flow.state, 'Added ' + flow.actual + '. Your cart now has ' + total + '.', cart);
  });
  document.addEventListener('cart:add:error', function (event) {
    var flow = submitFlow;
    if (!flow || flow.phase !== 'native' || event.target !== flow.form) return;
    finishAttempt(flow);
    showMessage(flow.state, 'Please check your cart for the latest available quantity.');
    refreshVisibleCart();
  });
  document.addEventListener('variant:change', function () { clearMessages(); schedule(); });
  document.addEventListener('cart:change', function (event) {
    var cart = event.detail && event.detail.cart;
    if (acceptCart(cart)) {
      if (drawerNotice && drawerNotice.cart !== cart) clearMessages();
      cartRevision += 1;
      cancelCartRead();
    } else refreshCart();
    schedule();
  });
  document.addEventListener('cart:refresh', refreshCart);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart();
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); schedule(); });
  function start() {
    init(document);
    refreshCart();
    new MutationObserver(function (records) {
      var added = false;
      records.forEach(function (record) {
        record.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(selector + ', [data-pdp-qty-price-map]') || node.querySelector(selector)) added = true;
        });
      });
      if (added) { init(document); schedule(); }
      if (drawerNotice) renderDrawerNotice();
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
